import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'xlsxLineError',
})
export class XlsxLineErrorPipe implements PipeTransform {
    transform(key: string): number {
        return Number(key) + 2;
    }
}
